import __request__ from "routing/request";
export function suggestFieldValue(validationRequest, requestOptions) {
  return __request__("POST", "/search/suggest", validationRequest, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function suggestQueryStrings(limit, requestOptions) {
  return __request__("GET", "/search/suggest/query_strings", null, { "limit": limit }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
